module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Table-of-Contents.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-8"
  }, [_c('p', {
    staticClass: "TOCtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('a', {
    attrs: {
      "href": "#/ThePrinceSheNeverKnew#Anchor-1"
    }
  }, [_vm._v("The Prince She Never Knew")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/KholodovsLastMistressofbook2#Anchor-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kholodov’s Last Mistress")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-462e2fbd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableofContents.vue
// module id = 69
// module chunks = 0